import { DicewarePassphrase } from 'shared-client/diceware-passphrase';
import { ApiClient } from './api-client.js';
import { WordList, InvalidWordValidation } from './word-list.js';

export type CompleteAddWordResult = {
  event: 'complete';
  passphrase: DicewarePassphrase;
};
export type InvalidAddWordResult = {
  event: 'invalid';
} & Pick<InvalidWordValidation, 'error' | 'suggestions'>;
export type IncompleteAddWordResult = {
  event: 'incomplete';
};
export type AddWordResult = CompleteAddWordResult | InvalidAddWordResult | IncompleteAddWordResult;

export class PassphraseHandler {
  private readonly wordList: WordList;
  constructor(
    readonly apiClient: ApiClient,
    wordList: string[],
    private readonly words: string[],
  ) {
    this.wordList = new WordList(wordList);
  }

  async addWord(word: string): Promise<AddWordResult> {
    const validation = this.wordList.validate(word);
    if (!validation.ok) {
      return {
        event: 'invalid',
        error: validation.error,
        suggestions: validation.suggestions,
      };
    }

    if (!this.words.length) {
      this.words.push(word);
      return { event: 'incomplete' };
    }
    const passphrase = new DicewarePassphrase(
      this.wordList.toArray(),
      [...this.words],
      word,
    );
    this.words.push(word);
    if (await passphrase.hasValidChecksum()) {
      return { event: 'complete', passphrase };
    }
    return { event: 'incomplete' };
  }

  async getDownloadDetails() {
    throw new Error('todo');
  }

  reset() {
    this.words.length = 0;
  }

  getWords() {
    return [...this.words];
  }

  getPassphrase() {
    return this.words.join('-');
  }

  static async fromApi() {
    const apiClient = await ApiClient.fromConfigJson();
    const wordList = await apiClient.getWordList();
    return new PassphraseHandler(apiClient, wordList, []);
  }
}
